import { z } from "zod/v4";

import {
  RedirectFilterList,
  RedirectQueryParamDtoSchema,
  UrlRedirectTypeList,
} from "../../../../dtos/redirects";
import { ShopifyTemplateType } from "../../../../dtos/shopify";

export const PluginRedirectSchema_2023_08_20 = z.object({
  id: z.uuid(),
  group: z.number(),
  testGroupId: z.uuid(),
  originUrl: z.string(),
  destinationUrl: z.string().nullish(),
  queryParams: RedirectQueryParamDtoSchema.array().default([]),
  skip: z.boolean(),
  isThemeTest: z.boolean(),
  isTemplateTest: z.boolean(),
  templateType: z.enum(ShopifyTemplateType).nullish(),
  templateSuffixes: z.string().array().nullish().default([]),
  redirectOnce: z.boolean().default(true),
  filter: z.enum(RedirectFilterList).default("matchesExactly"),
  find: z.string().nullish(),
  redirectType: z.enum(UrlRedirectTypeList).default("fullReplacement"),
});

export type PluginRedirectType_2023_08_20 = z.infer<
  typeof PluginRedirectSchema_2023_08_20
>;
